// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1lxKt","content":"LayoutSettings_content__2Ttma"};